import { DispatchersSectorsI } from '../interfaces/dispatchers_sectors.interface'
import { DispatchersSectorsService } from '../services/dispatchers_sectors.service'

import {
    DispatcherSectorPayloadT,
    DispatchersSectorsGetListResponseT,
} from '../types/dispatchers_sector.types'
import { SectorsGetListResponseT } from '../types/sectors.types'

const dispatchersSectorsService = new DispatchersSectorsService()

class DispatchersSectorsRealisation implements DispatchersSectorsI {
    attachUser(user_id: number, sector_ids: number[]): Promise<void> {
        return dispatchersSectorsService.attachUser(user_id, sector_ids)
    }

    getList(): Promise<DispatchersSectorsGetListResponseT> {
        return dispatchersSectorsService.getList()
    }

    getSectors(dispatcher_sector_id: number): Promise<SectorsGetListResponseT> {
        return dispatchersSectorsService.getSectors(dispatcher_sector_id)
    }

    updateSector(dispatcher_sector_id: number, payload: DispatcherSectorPayloadT): Promise<void> {
        return dispatchersSectorsService.updateSector(dispatcher_sector_id, payload)
    }

    createSector(payload: DispatcherSectorPayloadT): Promise<void> {
        return dispatchersSectorsService.createSector(payload)
    }

    deleteSector(dispatcher_sector_id: number): Promise<void> {
        return dispatchersSectorsService.deleteSector(dispatcher_sector_id)
    }
}

export const dispatchers_sectors = new DispatchersSectorsRealisation()
